module.exports = __webpack_public_path__ + "img/50.38cf3068.png";